var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainDuplicate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.056 1c.215 0 .482.051.684.254.203.202.26.475.26.69v9.823c0 .215-.057.482-.26.684-.202.203-.47.26-.684.26H12.71v4.345a.955.955 0 0 1-.944.944H1.944A.955.955 0 0 1 1 17.056V7.233c0-.513.431-.944.944-.944l4.344-.001V1.944c0-.215.058-.488.26-.69.203-.203.47-.254.685-.254h9.823zm-.19 1.133H7.423v4.155h4.345c.513 0 .944.432.944.945v4.344h4.156V2.134z",
    fill: "#90A9C0",
    fillRule: "nonzero",
    stroke: "#90A9C0",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainDuplicate);
export default __webpack_public_path__ + "static/media/main-duplicate.ebf64a4c6fdb7dad7bd823045fd39038.svg";
export { ForwardRef as ReactComponent };